import React from 'react';
import { NavLink } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash, FaEye } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import ActionAPI from '../../../api/ActionAPI';
import Util from '../../../util/Util';
import withRouter from '../../../util/WithRouter';
import Display from '../../../util/Display';
import Const from '../../../util/Constants';
import ApiUiController from '../../../controller/ApiUiController';

class ActionList extends React.Component {

  constructor(props) {
    super(props);
    this.actions = [];
    this.state = { inApiCall: true };
    this.path = this.props.match.path

    const model = reactLocalStorage.getObject(Const.Model).custom_action;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  componentDidMount() { 
    if(this.List) {
      ActionAPI.list(this.onReceived, this.onFail);
    }
  }

  onFail = () => this.setState({ inApiCall: false });
  onReceived = actions => { this.actions = actions; this.setState({ inApiCall: false }); }
  
  confirmDelete = index => {
    const message = `Are you sure you want to delete to ${this.actions[index].name}`;
    Util.confirmAlert('Delete', message, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      ActionAPI.delete(this.actions[index].id,this.onDelete, this.onFail);
    });
  }
  onDelete = () => {
    Util.showNotification('Successful', 'Deleted successfully.', 'success');
    ActionAPI.list(this.onReceived, this.onFail);
  }

  render() {
    if(!this.List) return null;
    const actionUI = this.actions.map((action, _i) => (
      <tr key={`action_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{action.name}</td>
        <td>{action.description}</td>
        <td>{Display.ModelLabelValue('user', action.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(action.created_date)}</td>
        <td>{Display.ModelLabelValue('user', action.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(action.updated_date)}</td>
        <td>
          <NavLink to={`${this.path}/preview/${action.id}`} className="buttons whtsapp"><FaEye /> Details</NavLink>
          { this.Update ? <NavLink to={`${this.path}/${action.id}`} className="buttons update"><FaPencilAlt /> Update</NavLink> : null }
          { this.Delete ? <span onClick={() => this.confirmDelete(_i)} className="buttons delete"><FaTrash /> Delete</span> : null  }
        </td>
      </tr>
    ));

    return (
      <>
        <div className="sectionlist pt-3">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 pb-3"> <h3>Custom Action Permission</h3> </div>
                <div className="col-md-6 text-right pb-3">
                  { this.Add &&
                    <NavLink to={`${this.path}/0`} className="buttons success">
                      + Action
                    </NavLink>
                  }
                </div>
                <div className="col-md-12">
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Created By</th>
                        <th>Created Date</th>
                        <th>Updated By</th>
                        <th>Updated Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                      <tbody>
                        <ApiUiController inApiCall={this.props.inApiCall}>
                          { actionUI }
                        </ApiUiController>
                      </tbody>
                    </Table>
                </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(ActionList);
